import { createApp, markRaw } from 'vue';
import { type ApiClient, createApi } from './api';
import { createMockApi } from '../../test/mocks/server';
import { createPinia } from 'pinia';

const createCustomApp: typeof createApp = (options) => {
  const app = createApp(options);

  // install pinia
  const pinia = createPinia();
  app.use(pinia);
  // $api はリアクティブにする必要がないため markRaw で包む
  // (包まない場合 pinia が PINIA_R1006 の診断を出力する)
  pinia.use(() => ({
    $api: markRaw(
      process.env.MOCK_SERVER === '1'
        ? (createMockApi() as ApiClient) // モック API は型定義を上書き
        : createApi(),
    ),
  }));

  return app;
};

export default createCustomApp;
